<template>
	<div class="main">
		<div class="goods-top">
			<div class="goods-top-main fl-c fr-c">
				<div class="goods-top-video fl-c fr-c" v-if="goodsDetails.videoUrl && isIndex === 0">
					<img :src="goodsDetails.videoImg" class="video-img" />
					<img src="../../assets/img/play_btn.png" class="video-btn" @click="playerVideo" />
				</div>
				<div class="goods-top-img" v-if="galleryList.length > 0 && isIndex === 1">
					<van-swipe class="my-swipe" indicator-color="#FF0000">
						<van-swipe-item v-for="(item, index) in galleryList" :key="index">
							<img :src="item.imgUrl" style="width: 100%; height: 100%;" />
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<div class="goods-top-tab" v-if="goodsDetails.videoUrl && galleryList.length > 0">
				<div class="goods-top-tab-main fr-c">
					<span :class="isIndex==0?'active':''" @click="isIndex=0">视频</span>
					<span :class="isIndex==1?'active':''" @click="isIndex=1">图片</span>
				</div>
			</div>
		</div>
		<div class="goods-center">
			<div class="fr-b-c goods-center-top">
				<span class="title">{{goodsDetails.goodsName}}</span>
				<span class="sale">月销{{goodsDetails.monthSaleNum}}</span>
			</div>
			<div class="goods-center-price fr-s-c">
				<span class="now-price" v-if="goodsDetails.memeberPrice"><i>￥</i>{{goodsDetails.memeberPrice}}</span>
				<del class="old-price">￥{{goodsDetails.goodsPrice}}</del>
			</div>
			<div class="goods-center-introduce fr-s-c" v-if="goodsDetails.goodsPrice">
				<span>“{{goodsDetails.goodsPrice}}”</span>
			</div>
		</div>

		<div class="goods-evaluate">
			<div class="goods-evaluate-top fr-b-c" @click="goDownload">
				<span>商品评价</span>
				<p class="fr-s-c">
					<i>查看全部</i>
					<img src="../../assets/img/goods_right.png" style="width: 0.2rem;" />
				</p>

			</div>
			<div class="goods-evaluate-box">
				<div class="goods-evaluate-li" v-for="(item, index) in evaluateLists" :key="index">
					<div class="goods-evaluate-li-top fr-b-c">
						<div class="left fr-s-c">
							<img :src="item.headImg" />
							<div class="fl-s-s">
								<span>{{item.nickName}}</span>
								<van-rate v-model="item.score" allow-half :icon="starRed" :void-icon="starGrey"
									:size="0.34+'rem'" readonly />
							</div>
						</div>
						<div class="right fr-s-c">
							<span>{{item.addTime | formatTime}}</span>
						</div>
					</div>
					<div class="goods-evaluate-li-bot">
						<p>{{item.commentContent}}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="goods-datails">
			<h3 class="title">商品详情</h3>
			<div class="goods-datails-main" v-html="goodsDetails.goodsDetails"></div>
		</div>

		<!-- 视频 -->
		<div class="video-div fl-c fr-c" v-show="isPlayer" @click.stop="isPlayer = false">
			<img src="../../assets/img/video-close.png" class="close"  @click.stop="isPlayer = false"/>
			<video :src="goodsDetails.videoUrl" id="videoplay" controls="controls"></video>
		</div>
		<!-- 底部导航条-->
		<div class="bottom_wrap">
			<div class="bottom">
				<div class="bottom_con">
					<div class="bottom_left">
						<div class="share_img">
							<img src="../../assets/img/logo.png" alt="">
						</div>
						<div class="share_des">
							<p>线上掌柜</p>
							<p>新人注册有红包</p>
						</div>
						<div class="clear"></div>
					</div>
					<div class="bottom_right" @click="goDownload">
						<div>立刻加入</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Field,
		Toast,
		Swipe,
		SwipeItem
	} from 'vant';
	import Vue from 'vue';
	import {
		goodsdetailsshareModule
	} from "../../request/myFreecharge";
	import {
		publicFun
	} from "@/tools/time.js"
	Vue.use(Field);
	Vue.use(Swipe);
	Vue.use(SwipeItem);
	export default {
		data() {
			return {
				goodsDetails: {},
				goosdsImg: [],
				starRed: require('../../assets/img/star_red.png'),
				starGrey: require('../../assets/img/star_grey.png'),
				evaluateLists: [],
				galleryList: [],
				isIndex: 0,
				isPlayer: false,
			}
		},
		filters: {
			formatTime: function(value) {
				console.log(value)
				return publicFun.timestampToTime(Number(value));
			},
		},
		created: async function() {
			await this.getactivitydetailshare()
		},
		methods: {
			async getactivitydetailshare() {
				// this.$route.query.goodsID = 77
				// this.$route.query.usertoken = 1628125022700
				await goodsdetailsshareModule.goodsdetailsshare(this.$route.query.goodsID, this.$route.query.usertoken)
					.then((response) => {
						console.log(response)
						switch (response.data.code) {
							case 100: {

								this.goodsDetails = response.data.result
								this.evaluateLists = response.data.result.commentList
								this.galleryList = response.data.result.galleryList
								if (this.goodsDetails.galleryList.length > 0) {
									this.isImgs = 1
								}
								if (this.goodsDetails.videoUrl) {
									this.isVideo = 1
								}

								console.log(response.data.result)
							}
							break;
						case 101:
							break;
						case 102:
							Toast.clear();
							break;
						case 100001:
							break;
						}
					}).catch(() => {})
			},
			playerVideo() {
				this.isPlayer = true;
				let obj = document.getElementById("videoplay")
				obj.play()
			},
			goDownload() {
				this.$router.push({
					path: '/download',
					query: {
						marktype: 1,
					}
				})

			},

		}
	}
</script>
<style scoped>
	.main {
		width: 100%;
		min-height: 100%;
		background: #F5F7FA;
	}

	.video-div {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		z-index: 999;
		top: 0;
		overflow: hidden;
	}

	.video-div video {
		width: 100%;
	}

	.close {
		display: block;
		position: fixed;
		width: 0.8rem;
		height: 0.8rem;
		top: 0.5rem;
		right: 0.5rem;
	}

	.header {
		font-size: 0.5rem;
		font-weight: bold;
		color: #323232;
		margin-left: 1.03rem;
		padding-top: 0.533rem;
	}

	.goods-top {
		width: 100%;
		height: 8.4rem;
		position: relative;
	}

	.goods-top .goods-top-main {
		width: 100%;
		height: 8.4rem;
	}

	.goods-top .goods-top-tab {
		position: absolute;
		width: 100%;
		height: 0.4rem;
		left: 0;
		bottom: 0.5rem;
	}

	.goods-top-video,
	.goods-top-img {
		width: 100%;
		height: 8.4rem;
		position: relative;
	}

	.goods-top-video .video-img {
		display: block;
		width: 100%;
		height: 8.4rem;
		position: absolute;
		top: 0;
		left: 0;
	}

	.goods-top-video .video-btn {
		width: 1.3rem;
		position: relative;
	}

	.goods-top-img .my-swipe {
		width: 100%;
		height: 8.4rem;
	}

	.goods-top-img .my-swipe img {
		display: block;
	}

	.goods-top-tab span {
		width: 0.9rem;
		height: 0.48rem;
		background: rgba(0, 0, 0, .5);
		opacity: 1;
		border-radius: 0.3rem;
		margin: 0 0.1rem;
		font-size: 0.24rem;
		color: #fff;
		text-align: center;
		line-height: 0.48rem;
	}

	.goods-top-tab span.active {
		background: linear-gradient(180deg, #FF5457 0%, #F90909 100%);
	}

	.goods-center {
		width: 100%;
		min-height: 3.1rem;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 0.4rem;
		margin-top: -0.32rem;
		position: relative;
		z-index: 9;
		padding-bottom: 0.8rem;
	}

	.goods-center-top {
		margin: 0 0.6rem;
		padding-top: 0.8rem;
	}

	.goods-center-top .title {
		width: 7rem;
		font-size: 0.4rem;
		font-weight: bold;
		color: #323232;
	}

	.goods-center-top .sale {
		font-weight: 400;
		color: #909090;
	}

	.goods-center-price {
		font-size: 0.4rem;
		font-weight: bold;
		color: #FF0000;
		margin: 0 0.56rem;
		padding-top: 0.48rem;
	}

	.goods-center-price i {
		font-size: 0.32rem;
		font-style: normal;
	}

	.goods-center-price .old-price {
		font-size: 0.32rem;
		font-style: normal;
		color: #909090;
		margin-left: 0.15rem;
		font-weight: 400;
	}

	.goods-center-introduce {
		margin: 0 0.56rem;
		padding-top: 0.48rem;
	}

	.goods-center-introduce span {
		color: #FF940B;
		border-radius: 0.08rem;
		padding: 0.05rem 0.15rem;
		background: #FFEDD5;
	}

	.goods-evaluate {
		margin-top: 0.53rem;
		background: #fff;
		width: 100%;
		border-radius: 0.4rem;
		overflow: hidden;
		color: #666;
		font-size: 0.266666rem;
		padding-bottom: 0.1rem;
	}

	.goods-evaluate-top {
		padding: 0.4rem 0.42rem;
	}

	.goods-evaluate-top span {
		font-size: 0.4rem;
		color: #1F1F1F;
		font-weight: 600;
	}

	.goods-evaluate-top i {
		font-size: 0.4rem;
		color: #909090;
		font-weight: 400;
		padding-right: 0.2rem;
		font-style: normal;
	}

	.goods-evaluate-li {
		margin-left: 0.42rem;
		padding-bottom: 0.32rem;
		border-bottom: 1px solid #eee;
		margin-bottom: 0.45rem;
		margin-right: 0.42rem;
	}

	.goods-evaluate-li:last-child {
		margin-bottom: 0;
		border-bottom: 0;
	}

	.goods-evaluate-li-top {
		padding: 0rem 0rem;
		margin-top: 0.1rem;
		margin-bottom: 0.3rem;
	}

	.goods-evaluate-li-top .left {
		color: #999;
		font-size: 0.306666rem;
	}

	.goods-evaluate-li-top .left img {
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		margin-right: 0.2rem;
	}

	.goods-evaluate-li-top .left span {
		padding-top: 0.3rem;
		margin-bottom: 0.1rem;
	}

	.goods-evaluate-li-top .right img {
		margin: 0 0.05rem;
	}

	.goods-evaluate-li-bot {
		padding: 0rem 0rem;
		color: #333;
		font-size: 0.35rem;
	}

	.goods-evaluate-li-bot span {
		color: #999;
		font-size: 0.29rem;
	}

	.goods-evaluate-li-bot p {
		margin-bottom: 0.2rem;
		margin-right: 0.42rem;
	}

	.goods-evaluate-li-bot img {
		width: 2.9rem;
		height: 2.4rem;
		margin-right: 0.2rem;
		margin-bottom: 0.16rem;
		border-radius: 0.2rem;
	}

	.goods-datails {
		margin-top: 0.53rem;
		background: #fff;
		width: 100%;
		border-radius: 0.4rem;
		overflow: hidden;
		color: #666;
		font-size: 0.266666rem;
		padding-bottom: 1.5rem;
	}

	.goods-datails .title {
		padding: 0.53rem 0.42rem;
		font-size: 0.42rem;
		font-weight: 500;
		color: #323232;
		text-align: center;
	}

	.goods-datails-main {
		padding: 0rem 0.42rem;
		color: #333;
		font-size: 0.35rem;
	}

	.goods-datails-main img {
		display: block;
		width: 100%;
	}
</style>
